import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  get(params) {
    const url = apiRoutes.presignUrlPath();

    return FetchHelpers.get(url, params, { rawData: true });
  },
};



// WEBPACK FOOTER //
// ./src/repositories/PresignUrlRepository.js